export const survTypeList = [
  { label: '1 - Fire', value: 1 },
  { label: '2 - Burglary', value: 2 },
  { label: '3 - Both', value: 3 }
]

export const recomCompList = [
  { label: '1 - Full', value: 1 },
  { label: '2 - Partial', value: 2 },
  { label: '3 - Ignored', value: 3 },
  { label: '4 - NA', value: 4 }
]

export const materialList = [
  { label: '1 - Glass', value: 1 },
  { label: '2 - Metal', value: 2 },
  { label: '3 - Wood', value: 3 },
  { label: '4 - Metal Gate', value: 4 },
  { label: '5 - Roller Shutter', value: 5 },
  { label: '6 - Concrete', value: 6 },
  { label: '7 - Brick', value: 7 },
  { label: '8 - Metal Klip-Lok', value: 8 },
  { label: '9 - Corrugated Asbestos Sheets', value: 9 },
  { label: '10 - Corrugated Zinc Sheets', value: 10 },
  { label: '11 - Clay Tiles', value: 11 },
  { label: '12 - Concrete & Metal Klip-Lok', value: 12 }
]

export const constnTypeList = [
  { label: '1 - Detached', value: 1 },
  { label: '2 - Semi Detached', value: 2 },
  { label: '3 - Terrace', value: 3 },
  { label: '4 - High Rise', value: 4 }
]

export const wiringTypeList = [
  { label: '1 - PVC Conduit', value: 1 },
  { label: '2 - Metal Trunking', value: 2 },
  { label: '3 - Metal Tray', value: 3 },
  { label: '4 - Exposed', value: 4 },
  { label: '5 - Poor Wiring', value: 5 }
]

export const cbTypeList = [
  { label: '1 - ELCB', value: 1 },
  { label: '2 - Electrical Panel', value: 2 },
  { label: '3 - None', value: 3 }
]

export const extTypeList = [
  { label: '1 - BCF', value: 1 },
  { label: '2 - CO2', value: 2 },
  { label: '3 - ABC Dry Chemical', value: 3 },
  { label: '4 - ABC Dry Powder', value: 4 },
  { label: '5 - Various Type', value: 5 }
]

export const satisficationList = [
  { label: '1 - Good', value: 1 },
  { label: '2 - Fair', value: 2 },
  { label: '3 - Poor', value: 3 }
]

export const ventList = [
  { label: '1 - Aircon', value: 1 },
  { label: '2 - Fan', value: 2 },
  { label: '3 - Natural', value: 3 }
]

export const wasteDispList = [
  { label: '1 - Contractor', value: 1 },
  { label: '2 - Own Cleaning', value: 2 }
]

export const wasteDispFreqList = [
  { label: '1 - Daily', value: 1 },
  { label: '2 - Monthly', value: 2 },
  { label: '3 - Quarterly', value: 3 },
  { label: '4 - Adhoc', value: 4 }
]

export const occpnClsList = [
  { label: '1 - Dwelling', value: 1 },
  { label: '2 - Office', value: 2 },
  { label: '3 - Shop', value: 3 },
  { label: '4 - Warehouse', value: 4 }
]

export const whsTypeList = [
  { label: '1 - Public', value: 1 },
  { label: '2 - Private', value: 2 },
  { label: '3 - Bonded', value: 3 }
]

export const partTypeList = [
  { label: '1 - Brick', value: 1 },
  { label: '2 - Gypsum Board', value: 2 },
  { label: '3 - Wire Mesh', value: 3 },
  { label: '4 - Corrugated Metal Sheets', value: 4 },
  { label: '5 - Nil', value: 5 }
]

export const alrmTypeList = [
  { label: '1 - ADT', value: 1 },
  { label: '2 - ADEMCO', value: 2 },
  { label: '3 - CISCO', value: 3 },
  { label: '4 - Sin Chew', value: 4 }
]

export const entProtectionList = [
  { label: '1 - Metal Gate', value: 1 },
  { label: '2 - Metal Grilles', value: 2 },
  { label: '3 - Metal Shutter', value: 3 },
  { label: '4 - Plateglass Door', value: 4 },
  { label: '5 - Plain Encased', value: 5 },
  { label: '6 - Single Leaf Door', value: 6 }
]

export const entLockTypeList = [
  { label: '1 - Latch', value: 1 },
  { label: '2 - Level', value: 2 },
  { label: '3 - Mortice Lock', value: 3 },
  { label: '4 - Padlock', value: 4 },
  { label: '5 - Shackle', value: 5 },
  { label: '6 - Combination & Key Lock', value: 6 },
  { label: '7 - Keycard Lock', value: 7 }
]

export const safeMakeList = [
  { label: '1 - Australian', value: 1 },
  { label: '2 - CHUBB', value: 2 },
  { label: '3 - Fichet Bache', value: 3 },
  { label: '4 - Kumahira', value: 4 }
]
